<template>
  <div class="authenticate">
    <div class="p-4 float-right">
      <router-link :to="{ name:'Register' }" class="ar-btn size-md round primary">ثبت نام</router-link>
    </div>
    <router-link :to="{name:'Home'}" class="p-2 float-left">
      <img class="logo-top" :src="this.StaticImageUrl + 'assets/images/logo/logo-dark.png'">
    </router-link>

    <div class="form-out">
      <div class="form-in text-center">

        <div class="icon-lg text-center">
          <div class="icon-wrapper">
            <img :src="this.StaticImageUrl + 'assets/images/site-icons/envelope.svg'" alt="">
          </div>
        </div>

        <div class="ar-form-group">
          <label for="">لطفا ایمیل خود را وارد کنید</label>
          <input class="ar-form-control text-center latin-input-3" type="text" v-model="data.email" placeholder="example@gmail.com">
          <div v-if="errors.email" class="ar-form-text">
            <small>{{errors.email[0]}}</small>
          </div>
        </div>
        <div v-if="errorMessage" class="ar-alert danger round mb-3">
          <small>{{errorMessage}}</small>
        </div>
      
        <div class="mb-4">
          <button @click="SendCode" class="ar-btn size-md block round primary">ورود</button>
        </div>

        <div class="text-center mb-2">
          <router-link :to="{ name:'LoginByPassword' }" class="ar-link info">ورود با رمز عبور</router-link>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'LoginByEmail',
  data : () => ({
    data:{
      email:'',
    },
    errorMessage:null,
    errors:{}
  }),
  watch:{
    
  },
  methods:{
    ...mapActions([
      'StoreEmail'
    ]),
    SendCode(){
      this.activeLoading(true)
      this.$axios.post(`sendVerifyCodeByEmail` , this.data)
      .then(res => {
        this.StoreEmail(this.data.email);
        this.$router.push({name:'EmailVerifyCode'});
        this.activeLoading(false)
      })
      .catch(err => {
        if(err.response.data.message){
          this.errorMessage = err.response.data.message
          this.errors = {}
        }else if(err.response.data.errors){
          this.errors = err.response.data.errors
          this.errorMessage = null
        }
        this.activeLoading(false)
      });
    }
  },
  mounted() {
    this.activeLoading(false)
    this.checkUnAuthenticated()
  }
}
</script>
